import {
  contactInfoTypeOptionsTranslation,
  ContactInfoTypeOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { AddContactInfoFormModel } from '@/views/contactsDetails/components/header/components/addContactInfoButton/model/AddContactInfoForm.model.ts';

export type ContactDetailsInfosTranslation = {
  dialog: {
    button: {
      cancel: string;
      submit: string;
    };
    form: Record<keyof AddContactInfoFormModel, string> & {
      contactInfoTypeOptions: ContactInfoTypeOptionsTranslation;
    };
    title: string;
  };
};

export const contactDetailsInfosTranslation: ContactDetailsInfosTranslation = {
  dialog: {
    button: {
      cancel: 'Anuluj',
      submit: 'Zapisz',
    },
    form: {
      contactInfoType: 'Typ kontaktu',
      contactInfoTypeOptions: contactInfoTypeOptionsTranslation,
      note: 'Notatka',
      value: 'Wartość',
    },
    title: 'Dodaj dane kontaktowe',
  },
};
